import { $host } from ".";

// Get all vacancies
export const fetchVacancies = async () => {
    try {
        const { data } = await $host.get('api/vacancy');
        return data;
    } catch (error) {
        console.error("Error fetching vacancies:", error);
        return error;
    }
};

// Get one vacancy by ID
export const fetchVacancy = async (id) => {
    try {
        const { data } = await $host.get('api/vacancy/' + id);
        return data;
    } catch (error) {
        console.error("Error fetching vacancy:", error);
        return error;
    }
};

// Create a new vacancy
export const createVacancy = async (vacancy) => {
    try {
        const { data } = await $host.post('api/vacancy', vacancy);
        return data;
    } catch (error) {
        console.error("Error creating vacancy:", error);
        return error;
    }
};

// Update an existing vacancy
export const updateVacancy = async (id, vacancy) => {
    try {
        const { data } = await $host.put('api/vacancy/' + id, vacancy);
        return data;
    } catch (error) {
        console.error("Error updating vacancy:", error);
        return error;
    }
};

// Delete a vacancy
export const deleteVacancy = async (id) => {
    try {
        const { data } = await $host.delete('api/vacancy/' + id);
        return data;
    } catch (error) {
        console.error("Error deleting vacancy:", error);
        return error;
    }
};
